<app-modal
  [isOpen]="isOpen"
  (close)="onClose()"
  className="max-w-4xl mx-4 sm:mx-6"
>
  @if (rule) {
    <div class="p-6 sm:p-8">
      <!-- Header -->
      <div class="flex items-start justify-between gap-6 mb-8">
        <div>
          <div class="flex items-center gap-2 mb-1">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
              {{ getRuleTypeLabel(rule.ruleType) }}
            </h3>
            <app-badge
              [color]="getStatusColor()"
              size="sm"
              >{{ getStatusLabel() }}</app-badge
            >
          </div>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ rule.description || 'Sin descripción' }}
          </p>
        </div>
      </div>

      <!-- Tabs -->
      <div class="border-b border-gray-200 dark:border-gray-700 mb-6">
        <button
          type="button"
          (click)="onTabChange('info')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'info'"
          [class.text-brand-600]="activeTab === 'info'"
          [class.dark:text-brand-400]="activeTab === 'info'"
          [class.border-transparent]="activeTab !== 'info'"
          [class.text-gray-500]="activeTab !== 'info'"
          [class.hover:text-gray-700]="activeTab !== 'info'"
          [class.dark:text-gray-400]="activeTab !== 'info'"
        >
          Información
        </button>
        <button
          type="button"
          (click)="onTabChange('timeline')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'timeline'"
          [class.text-brand-600]="activeTab === 'timeline'"
          [class.dark:text-brand-400]="activeTab === 'timeline'"
          [class.border-transparent]="activeTab !== 'timeline'"
          [class.text-gray-500]="activeTab !== 'timeline'"
          [class.hover:text-gray-700]="activeTab !== 'timeline'"
          [class.dark:text-gray-400]="activeTab !== 'timeline'"
        >
          Línea de tiempo
        </button>
      </div>

      <!-- Content -->

      @if (activeTab === 'info') {
        <div class="space-y-5">
          <!-- Descuento -->
          <section>
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Descuento
            </h4>
            <div class="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Valor</p>
                <p class="font-semibold text-brand-600 dark:text-brand-400">
                  {{ getDiscountLabel() }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Tipo de descuento</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{
                    rule.discountType === 'percent'
                      ? 'Porcentaje'
                      : rule.discountType === 'fixed_amount'
                        ? 'Monto fijo'
                        : '-'
                  }}
                </p>
              </div>
            </div>
          </section>

          <!-- Cantidades (volume) -->
          @if (rule.ruleType === 'volume') {
            <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h4
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
              >
                Cantidades
              </h4>
              <div class="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <p class="text-xs text-gray-500">Mínima</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ rule.minQuantity ?? '-' }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Máxima</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ rule.maxQuantity ?? 'Sin límite' }}
                  </p>
                </div>
              </div>
            </section>
          }

          <!-- Cupón -->
          @if (rule.ruleType === 'coupon') {
            <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h4
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
              >
                Cupón
              </h4>
              <div class="grid grid-cols-3 gap-3 text-sm">
                <div>
                  <p class="text-xs text-gray-500">Código</p>
                  <p
                    class="font-mono font-semibold text-gray-800 dark:text-gray-200"
                  >
                    {{ rule.couponCode }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Usos</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ rule.currentUses ?? 0 }} / {{ rule.maxUses ?? '∞' }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Restantes</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ rule.usesRemaining ?? '-' }}
                  </p>
                </div>
              </div>
            </section>
          }

          <!-- Precio mínimo -->
          @if (rule.ruleType === 'min_price') {
            <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
              <h4
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
              >
                Precio mínimo
              </h4>
              <p class="text-sm text-gray-800 dark:text-gray-200">
                {{ formatPrecio(rule.minSalePrice) }}
              </p>
            </section>
          }

          <!-- Producto / Contacto -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Alcance
            </h4>
            <div class="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Producto</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ getProductLabel() }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Contacto</p>
                <p class="text-gray-800 dark:text-gray-200"
                   [title]="rule.contactId ? 'Identificador interno: ' + rule.contactId : ''">
                  {{ rule.contactName || (rule.contactId ? 'Contacto sin nombre disponible' : 'Todos') }}
                </p>
              </div>
            </div>
          </section>

          <!-- Vigencia -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Vigencia
            </h4>
            <div class="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Desde</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ formatDateOnly(rule.validFrom) }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Hasta</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ formatDateOnly(rule.validUntil) }}
                </p>
              </div>
            </div>
          </section>

          <!-- Metadata -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Metadata
            </h4>
            <div class="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Creada</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ formatDate(rule.datetimeCreated) }}
                </p>
              </div>
            </div>
          </section>
        </div>
      }

      <!-- ========== TAB: TIMELINE ========== -->
      @if (activeTab === 'timeline') {
        <app-audit-timeline
          [logs]="timelineLogs"
          [loading]="loadingTimeline"
          [error]="timelineError"
          [currentPage]="timelinePage"
          [totalPages]="timelineTotalPages"
          [totalElements]="timelineTotalElements"
          emptyMessage="No hay eventos de auditoría para este negocio."
          (pageChange)="loadTimeline($event)"
        />
      }
      <!-- end timeline tab -->
    </div>
  }
</app-modal>
